export default {
    namespaced: true,
    state:{
        page:1,
        customers:[]
    },
    actions:{

    },
    mutations:{
        updatePage(state, page){
            state.page = page
        }
    }
}
